<template>
  <div class="app-container">
    <div class="filter-container">
      <div
        v-for="item in routes_type"
        :key="item.key"
        :class="['item', { active: activeType === item.key }]"
        @click="handleChangeType(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <component :is="activeType" />
  </div>
</template>

<script>
import ipMonitor from "./ipMonitor";
import ipManagement from "./ipManagement";

const ROUTES_TYPE = [
  { key: "ipMonitor", name: "IP Monitor" },
  { key: "ipManagement", name: "IP Management" }
];

export default {
  components: {
    ipMonitor,
    ipManagement
  },
  data() {
    return {
      activeType: "",
      routes_type: ROUTES_TYPE
    };
  },
  created() {
    this.handleChangeType(this.routes_type[0]);
  },
  methods: {
    handleChangeType(item) {
      this.activeType = item.key;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .filter-container {
    padding: 20px 18px 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .item {
      padding: 7px 4px;
      width: 200px;
      text-align: center;
      background: #ebedf3;
      color: #333333;
      cursor: pointer;
      font-size: 14px;
      margin-right: 2px;
      &:first-child {
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        border-radius: 0 4px 4px 0;
      }
      &:nth-child(2) {
        border-left: 0;
        border-right: 0;
      }
    }
    .active {
      background-color: #00a791;
      color: #fff;
    }
  }
}
</style>
